import apiRequest from '../../js/helpers/apiRequest.js';
import {
  SET_COURSES,
  SET_COURSE,
  SET_VIEW_COURSE,
  SET_SEARCH_COURSES,
  SET_PURCHASED_COURSES,
  SET_FAVORITES_COURSES,
} from '../mutations.js';
import app from '../../js/app.js';
import notify from '../../js/helpers/notify.js';

const mapCourseResponse = (array) => {
  return array
    .map(
      ({
        id,
        active,
        updated_at,
        desc,
        image,
        language_id,
        name,
        price,
        price_desc,
        special_price,
        recommended,
        short_desc,
        source_language_id,
        time,
        reviews_data: { reviews_avg, reviews_count },
      }) => ({
        id,
        active: !!active,
        updatedAt: updated_at,
        desc: {
          long: desc,
          short: short_desc,
        },
        preview: image,
        languageId: language_id,
        name,
        price: {
          base: price,
          special: special_price,
          desc: price_desc,
        },
        rating: {
          avg: reviews_avg,
          count: reviews_count,
        },
        recommended: !!recommended,
        sourceLanguageId: source_language_id,
        time,
      })
    )
    .filter((course) => course.active);
};

export default {
  state: {
    courses: [],
    found: [],
    purchased: [],
    favorites: [],
    course: null,
    viewCourse: null,
  },

  mutations: {
    SET_COURSES(state, courses) {
      state.courses = courses;
    },

    SET_SEARCH_COURSES(state, courses) {
      state.found = courses;
    },

    SET_PURCHASED_COURSES(state, purchased) {
      state.purchased = purchased;
    },

    SET_FAVORITES_COURSES(state, favorites) {
      state.favorites = favorites;
    },

    SET_COURSE(state, course) {
      state.course = course;
    },

    SET_VIEW_COURSE(state, course) {
      state.viewCourse = course;
    },
  },

  actions: {
    async getCourses({ commit }) {
      try {
        const res = await apiRequest('courses', 'GET', null);

        if (res.success) {
          commit(SET_COURSES, mapCourseResponse(res.success.courses));
        }
      } catch (error) {
        console.log(error);
      }
    },

    async getPurchasedCourses({ commit }) {
      try {
        const res = await apiRequest('bought/courses', 'GET', null, true);

        if (res.success) {
          commit(SET_PURCHASED_COURSES, mapCourseResponse(res.success));
        }
      } catch (error) {
        console.log(error);
      }
    },

    async getFavoriteCourses({ commit }) {
      try {
        const res = await apiRequest('favorited/courses', 'GET', null, true);

        if (res.success) {
          commit(SET_FAVORITES_COURSES, mapCourseResponse(res.success));
        }
      } catch (error) {
        console.log(error);
      }
    },

    async getCourse({ commit }, id) {
      try {
        const res = await apiRequest(`get/course/${id}`, 'GET', null, true);

        if (res.success) {
          const {
            id,
            active,
            image,
            content,
            updated_at,
            time,
            asks,
            special_price,
            source_language_id,
            desc,
            short_desc,
            recommended,
            price_desc,
            price,
            name,
            reviews_data: { reviews_avg, reviews_count },
            language_id,
          } = res.success;

          console.log(JSON.parse(content), 'content');

          commit(SET_COURSE, {
            id,
            active: !!active,
            updatedAt: updated_at,
            desc: {
              long: desc,
              short: short_desc,
            },
            content: JSON.parse(content),
            preview: image,
            languageId: language_id,
            name,
            price: {
              base: price,
              special: special_price,
              desc: price_desc,
            },
            rating: {
              avg: reviews_avg,
              count: reviews_count,
            },
            recommended: !!recommended,
            sourceLanguageId: source_language_id,
            time,
            asks,
          });
        }
      } catch (error) {
        console.log(error);
      }
    },

    async viewCourse({ commit }, id) {
      try {
        const res = await apiRequest(`preview/course/${id}`, 'GET', null);

        if (res.success) {
          const {
            id,
            active,
            image,
            updated_at,
            time,
            special_price,
            source_language_id,
            desc,
            short_desc,
            recommended,
            price_desc,
            price,
            name,
            reviews_data: { reviews_avg, reviews_count },
            language_id,
          } = res.success;

          commit(SET_VIEW_COURSE, {
            id,
            active: !!active,
            updatedAt: updated_at,
            desc: {
              long: desc,
              short: short_desc,
            },
            preview: image,
            languageId: language_id,
            name,
            price: {
              base: price,
              special: special_price,
              desc: price_desc,
            },
            rating: {
              avg: reviews_avg,
              count: reviews_count,
            },
            recommended: !!recommended,
            sourceLanguageId: source_language_id,
            time,
          });
        }
      } catch (error) {
        console.log(error);
      }
    },

    async searchCourses({ commit }, val) {
      if (!val.length) {
        commit(SET_SEARCH_COURSES, []);
      } else {
        try {
          app.$f7.progressbar.show();
          const res = await apiRequest(`courses/search?query=${val}`);

          if (res.success) {
            if (!res.success.courses.length) {
              notify({
                text: `${app.$t(`upon_request`)} "${val}" ${app.$t(
                  `nothing_found`
                )}.`,
                duration: 3000,
              });
            } else {
              commit(
                SET_SEARCH_COURSES,
                mapCourseResponse(res.success.courses)
              );
            }
          }
        } catch (error) {
          console.log(error);
          commit(SET_SEARCH_COURSES, []);
        } finally {
          app.$f7.progressbar.hide();
        }
      }
    },

    async reviewCourses({ dispatch }, { id, rating }) {
      try {
        const body = new FormData();
        body.append('stars', rating);

        const res = await apiRequest(`review/course/${id}`, 'POST', body, true);

        if (res.success) {
          notify({ text: res.success, duration: 3000 });
          return dispatch('getPurchasedCourses');
        } else if (res.error) {
          notify({ text: res.error.message, duration: 3000 });
        }
      } catch (error) {
        console.log(error);
      }
    },

    async addToFavorites({ dispatch }, id) {
      app.$f7.progressbar.show();
      try {
        const res = await apiRequest(
          `favorite/course/${id}`,
          'POST',
          null,
          true
        );

        if (res.success) {
          notify({ text: res.success, duration: 3000 });
          return dispatch('getFavoriteCourses');
        } else if (res.error) {
          notify({ text: res.error.message, duration: 3000 });
        }
      } catch (error) {
        console.log(error);
      } finally {
        app.$f7.progressbar.hide();
      }
    },

    async checkLesson({ dispatch }, { id, lessonId }) {
      try {
        const res = await apiRequest(
          `progress/course/${id}/${lessonId}`,
          'POST',
          null,
          true
        );

        if (res.success) {
          return dispatch('getCourse', id);
        }
      } catch (error) {
        console.log(error);
      }
    },

    async uncheckLesson({ dispatch }, { id, lessonId }) {
      try {
        const res = await apiRequest(
          `unprogress/course/${id}/${lessonId}`,
          'POST',
          null,
          true
        );

        if (res.success) {
          return dispatch('getCourse', id);
        }
      } catch (error) {
        console.log(error);
      }
    },
  },
};
